import instance from "../axios";

export const getAllBooths = async () => {
  const response = await instance.get("booths/get-all");
  return response.data;
};

export const getRefundBoothList = async () => {
  const response = await instance.get("booths/get-refund-booth-list");
  return response.data;
};

export const groupByCity = async (cityID) => {
  const response = await instance.get("booths/group-by-city/" + cityID);
  return response.data;
};
export const getCities = async () => {
  const response = await instance.get("booths/cities");
  return response.data;
};
